import React, { FC } from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { getSeoProperties } from 'features/page-model/ducks/get-model';
import { getBaseUrl } from 'common/selectors/location';

export const AnalyticsPageMeta: FC = () => {
  const { pageTitle, metakeywords, metadescription } = useSelector(getSeoProperties) || {};
  const currentUrl = useSelector(getBaseUrl);
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="keywords" content={metakeywords ?? ''} />
      <meta name="description" content={metadescription ?? ''} />
      <meta property="og:title" content={pageTitle ?? ''} />
      <meta property="og:description" content={metadescription ?? ''} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
    </Helmet>
  );
};
